import React from 'react'
import ContainerCover from '../../common/components/ContainerCover'
import HOMEDESKTOP from '../images/homeDesktop.png'
import HOMEMOBILE from '../images/homeMobile.png'
import HOMETABLET from '../images/homeTablet.png'
import { PALETTE } from '../../common/ThemeConstants'
import { IoIosArrowDown } from "react-icons/io"

import { useWindowWidth } from '../../api/useWindowWidth'
import { Container } from 'react-bootstrap'
import InstallButtonSection from './InstallButtonSection'

export default function HomeCover() {
  const [_, isMobile, isTablet] = useWindowWidth()
  let homeImage = HOMEMOBILE
  if (isMobile) {
    homeImage = HOMEMOBILE
  } else if (isTablet) {
    homeImage = HOMETABLET
  } else {
    homeImage = HOMEDESKTOP
  }

  return (
    <Container>
      <ContainerCover backgroundImage={homeImage} className="align-self-center text-center" />
      <div className="align-items-end text-center" style={{ position: "absolute", left: 0, right: 0, bottom: 20 }}>
        <InstallButtonSection />
        <div className="blink mt-3">
          <a
            href="#services"
            className="text-center text-decoration-none"
            style={{ color: PALETTE.MAINCOLOR }}
          >
            <IoIosArrowDown size={45} />
          </a>
        </div>
      </div>
    </Container>
  )
}
